export const Routes = [
  {
    label: "Reports",
    iconType: "reportingApp",
    childRoutes: [
      {
        label: "Search Table",
        path: "/reports/search-table",
      },
      {
        label: "Data Grid",
        path: "/reports/data-grid",
      },
      {
        label: "Charts",
        path: "/reports/charts",
      },
    ],
  },
  //   {
  //     label: "Management",
  //     iconType: "managementApp",
  //     childRoutes: [
  //       {
  //         label: "Extraction Test",
  //         path: "/manage/extraction",
  //       },
  //       {
  //         label: "Set Template",
  //         path: "/manage/template",
  //       },
  //       {
  //         label: "Taxes",
  //         path: "/manage/taxes",
  //       },
  //     ],
  //   },
  //   {
  //     label: "Learn",
  //     iconType: "training",
  //     childRoutes: [{ label: "Docs" }, { label: "Blogs" }],
  //   },
];
